const setCompanyEmailInputPattern = require("../validation/setCompanyEmailInputPattern");

/**
 * @return {void}
 */
module.exports = function setCompanyEmailInputPatterForAllCompanyEmailInputs() {
    document.querySelectorAll('[data-component="company-email-input"]').forEach(companyEmailInput => {
        setCompanyEmailInputPattern(companyEmailInput);
    });
}